import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

export interface CompanyReceiptScansObject {
  companyId: number;
  attachmentCount: number;
}

export type CompanyReceiptScans = CompanyReceiptScansObject[];

const useCompanyReceiptScansApi = (immediate: boolean = true) => {
  const call = useCallback(async () => {
    try {
      const res = await axiosInstance.get<CompanyReceiptScans>(api.companyReceiptScans);
      return res.data;
    } catch (error) {
      console.error(error);
      return [];
    }
  }, []);
  const { value, execute } = useAsync(call, immediate);

  return { companyReceiptScans: value || [], getCompanyReceiptScans: execute };
};

export default useCompanyReceiptScansApi;
